<ftr-side-nav-shell
  [displayMode]="displayMode"
  [expanded]="expanded"
  [isLoading]="isLoading"
  [isOpened]="isOpened"
  [navGroups]="navGroups()"
  [footerItems]="footerItems()"
  elevioArticleId="TODO"
  elevioHelpIcon="HelpCircleLine"
  theme="light"
  (sideBarToggled)="sideBarToggled.emit()"
  (expandedToggled)="expandedToggled.emit()"
>
  <a sideNavHeader class="public-side-nav-logo" [routerLink]="['/']" aria-label="Go to home">
    <ftr-logo
      [size]="expanded ? logoSize.Small : logoSize.ExtraSmall"
      [theme]="expanded ? logoTheme.Themed : logoTheme.ThemedNoText"
      [fullWidth]="true"
      [static]="true"
    />
  </a>
  <ftr-user-and-org-dropdown
    sideNavSubHeader
    theme="light"
    [collapsed]="!expanded"
    [displayMode]="displayMode"
    [style.width]="'100%'"
    (dropdownOpened)="onUserDropdownOpened($event)"
  />
</ftr-side-nav-shell>
